//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavFunctions(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6.57167 12L11.1167 16.545L7.58167 20.0817L2 14.5V9.5L9.5 2H14.5L15.535 3.035L6.57167 12Z" fill="currentColor" /><path d="M12.8832 7.45504L16.4198 3.92004L21.9998 9.50004V14.5L14.4998 22H9.49984L8.46484 20.965L17.4282 12L12.8832 7.45504Z" fill="currentColor" /></svg>;
}
export default IconNavFunctions;